import { render, staticRenderFns } from "./DashboardWidgetTurnoverTrend.vue?vue&type=template&id=76dcd7b9&"
import script from "./DashboardWidgetTurnoverTrend.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetTurnoverTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports